import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateRegisterCustomerInfo,
  updateChildrenInfo,
  createChildrenInfo,
  deleteChildrenInfo,
  verifyIdentity,
  sendSmsByCp,
  verifySmsAuthNo,
  retrySmsByCp,
  customerProspect,
  checkAgeInfo,
  initialState,
  checkUnderAgeList,
} from '@store/actions/registerAction';
import { showModal, saveInProgress } from '@store/actions/commonAction';
import {
  is3rdTelCo,
  KOREAN_NAME_FOREIGNER_ALERT_MESSAGE,
} from '@common/constants';
import { toPhone } from '@common/utils/validation';
import Layout from '@components/common/Layout';
import SatInput from '@components/common/satUI/SatInput';
import SatButton from '@components/common/satUI/SatButton';
import SatModal from '@components/common/satUI/SatModal';
import {
  TermsAgree,
  CustomerAuthSms,
  MobileTermsAgree,
  RegisterPlanAgreement,
  IdCheckTermsAgreePopup,
  TestAuth,
  RegisterChildrenInput,
  CustomerRegisterInput,
  CustomerRegisterVerifyId,
  RegisterAgreeSmsSendPopupArea,
} from '@container/customer';

//import firebase from 'firebase/app';

const registerRsdnKey = 'registerRsdnKey'; // 고객 정보 주민번호 뒷자리 보안키
const registerDriverNumberKey = 'registerDriverNumberKey'; // 신분증 인증 운전면허 번호 보안키
const registerChildrenRsdnKey = 'registerChildrenRsdnKey'; // 고객 정보 추가 자녀 주민번호 뒷자리 보안키

const CustomerAuth = () => {
  const { bannedPhoneNumberInfos } = $hooks.useConstant();
  const { isRestrictedUser } = $hooks.useUser();

  const { registerCustomerInfo, registerInitState } = useSelector(
    state => state.registerReducer,
  );
  const { inProgress } = useSelector(state => state.commonReducer);
  const dispatch = useDispatch();
  const [isShowAuthSmsPopup, setIsShowAuthSmsPopup] = useState(false);
  const [certSmsData, setCertSmsData] = useState();
  const [showRegisterPlanAgreement, setShowRegisterPlanAgreement] =
    useState(false);
  const [agreeCheckList, setAgreeCheckList] = useState(Array(9).fill(''));
  const [checkAgree2, setCheckAgree2] = useState(false);
  const [isShowAgreePopup, setIsShowAgreePopup] = useState(false);
  const agreePopupRef = useRef();
  const mobileTelNoRef = useRef();
  const [showMobiletermsAgree, setShowMobiletermsAgree] = useState(false);
  const [identifyBtnDisabled, setIdentifyBtnDisabled] = useState(true);
  const [isSmsSendPopupVisible, setIsSmsSendPopupVisible] = useState(false); // sms전송팝업
  const [isShowResetPopup, setIsShowResetPopup] = useState(false); // sms전송팝업

  const clearRegisterData = () => dispatch(initialState());

  useEffect(() => clearRegisterData, []);

  useEffect(() => {
    handleValidationCheck();
  }, [registerCustomerInfo]);

  useEffect(() => {
    let array = [...inProgress];
    if (
      JSON.stringify(registerCustomerInfo) !== JSON.stringify(registerInitState)
    ) {
      array = array.concat('/register');
    } else {
      array = array.filter(item => item !== '/register');
    }

    dispatch(saveInProgress([...new Set(array)]));
  }, [registerCustomerInfo]);

  useEffect(() => {
    // firebase.analytics().logEvent('screen_view', {
    //   firebase_screen: '가입설계동의',
    //   firebase_screen_class: 'RegisterAgree',
    // });
  }, []);

  // input 입력값 검증
  const handleValidationCheck = () => {
    const isDisabled = $utils.checkValidCustomerAuth(registerCustomerInfo);
    setIdentifyBtnDisabled(isDisabled);
  };

  // 절대 삭제 금지 - 실제 존재하는 아래 고객 번호 사용 금지 로직
  const forbidCustomerMobileTelNo = () => {
    const bannedPhoneNumberMessage = $utils.getBannedPhoneNumberMessage(
      registerCustomerInfo.mobileTelNo,
      bannedPhoneNumberInfos,
    );

    if (bannedPhoneNumberMessage) {
      dispatch(
        showModal({
          visible: true,
          type: 'info',
          msg: bannedPhoneNumberMessage,
        }),
      );
      return;
    }
    return true;
  };

  const handleSMSClick = () => {
    if (forbidCustomerMobileTelNo()) {
      setIdentifyBtnDisabled(false);
      setIsShowAgreePopup(true);
    }
  };

  const handleIdCardClick = () => {
    if (forbidCustomerMobileTelNo()) {
      setIdentifyBtnDisabled(false);
      agreePopupRef.current.clearCheck();
      agreePopupRef.current.showPopup();
    }
  };

  const handleInputMobileTelNoEvent = value => {
    dispatch(
      updateRegisterCustomerInfo({
        mobileTelNo: value,
      }),
    );
  };

  const handleAddChildrenClick = () => {
    const child = {
      index: registerCustomerInfo.relationCustomers.length,
      name: '',
      rsdn1: '',
      rsdn2: '',
    };
    dispatch(createChildrenInfo(child));
  };

  // 나이 체크
  const handleCheckAgeInfo = () => {
    const payload = {
      callback: checkAgeInfoCallback,
    };
    dispatch(checkAgeInfo(payload));
  };

  const checkAgeInfoCallback = result => {
    // 외국인이 한글 성명 여부 체크 변수
    const isKoreaNameForeigner =
      result.foreigner &&
      $utils.checkKoreaIncludedText(registerCustomerInfo.customerName);

    if (registerCustomerInfo?.relationCustomers?.length > 0) {
      handleCheckUnderAgeList(isKoreaNameForeigner);
    } else if (isKoreaNameForeigner) {
      dispatch(
        showModal({
          visible: true,
          type: 'confirm',
          msg: KOREAN_NAME_FOREIGNER_ALERT_MESSAGE,
          onOk: {
            handle: () => handleIdentifyClick(),
          },
        }),
      );
    } else {
      handleIdentifyClick();
    }
  };

  // 자녀 나이 체크
  const handleCheckUnderAgeList = isKoreaNameForeignerCustomer => {
    const payload = {
      callback: (isUnderAge, isKoreaNameForeignerRelationCustomer) => {
        if (!isUnderAge) return;

        if (
          isKoreaNameForeignerCustomer ||
          isKoreaNameForeignerRelationCustomer
        ) {
          dispatch(
            showModal({
              visible: true,
              type: 'confirm',
              msg: KOREAN_NAME_FOREIGNER_ALERT_MESSAGE,
              onOk: {
                handle: () => handleIdentifyClick(),
              },
            }),
          );
        } else {
          handleIdentifyClick();
        }
      },
    };

    dispatch(checkUnderAgeList(payload));
  };

  // 확인하고 인증하기
  const handleIdentifyClick = () => {
    // 가입설계동의 전자청약 구분 (동일 api 사용 chkCertiSms /chkIndentifyCard)
    dispatch(
      updateRegisterCustomerInfo({
        bizKind: '01',
        // bizKind: 'LPS',
      }),
    );
    // 약관동의 팝업
    // SMS
    if (registerCustomerInfo.verifyType === 'SMS') {
      console.log('약관동의 팝업');
      handleSMSClick();
    } else {
      // 신분증
      handleIdCardClick();
    }
  };

  // 초기화
  const handleReset = () => {
    dispatch(initialState());
    setIsShowResetPopup(false);
  };

  const inputComplete = () => {
    setIsShowAgreePopup(false);
    setAgreeCheckList(Array(9).fill(''));
    setCheckAgree2(false);
    dispatch(verifyIdentity({ callback: sendCertNameResult }));
  };

  const clickCloseTermsAgree = () => {
    setIsShowAgreePopup(false);
    setAgreeCheckList(Array(9).fill(''));
    setCheckAgree2(false);
  };

  const handleShowTerms = targetId => {
    setIsShowAgreePopup(false);
    if ('terms1' === targetId) {
      // firebase.analytics().logEvent('screen_view', {
      //   firebase_screen: '동의서 전문 읽기',
      //   firebase_screen_class: 'ReadAgreement',
      // });

      setShowRegisterPlanAgreement(true);
    } else if ('terms2' === targetId) {
      setShowMobiletermsAgree(true);
    }
  };

  const sendCertNameResult = success => {
    if (success) {
      // sms 발송
      dispatch(sendSmsByCp({ callback: sendSmsResult }));
    }
  };

  const sendSmsResult = (success, data) => {
    if (success) {
      setIsShowAuthSmsPopup(true);
      setCertSmsData(data?.data || data);
    }
  };

  const clickCloseAuthSms = () => {
    setIsShowAuthSmsPopup(false);
  };

  // 인증 번호 검증
  const handleVerifyAuthNo = authNo => {
    dispatch(
      verifySmsAuthNo({
        userInfo: {
          certiNo: authNo,
          pccSeq: certSmsData.pccSeq,
          authSeq: certSmsData.authSeq,
          reqNo: certSmsData.reqNo,

          // reqType: 'C' 로 보낼 때 추가
          logId: certSmsData.logId,
          reqInfo: certSmsData.reqInfo,
          confirmSeq: certSmsData.confirmSeq,
        },
        callback: verifyAuthNoResult,
      }),
    );
  };

  const handleRetry = isDone3Minutes => {
    if (isDone3Minutes) {
      dispatch(sendSmsByCp());
    } else {
      dispatch(
        retrySmsByCp({
          userInfo: {
            pccSeq: certSmsData.pccSeq,
            authSeq: certSmsData.authSeq,
            confirmSeq: certSmsData.confirmSeq,
            reqNo: certSmsData.reqNo,
          },
          callback: (success, data) => {
            if (success) {
              setCertSmsData(data);
            }
          },
        }),
      );
    }
  };

  const verifyAuthNoResult = (success, data) => {
    if (success) {
      setIsShowAuthSmsPopup(false);
      dispatch(
        customerProspect({
          certiHistoryNo: data.data.certiHistoryNo,
        }),
      );
    }
  };

  const handleChildrenInputEvent = (value, index, targetId) => {
    dispatch(
      updateChildrenInfo({
        value: value,
        index: index,
        targetId: targetId,
      }),
    );
  };

  const handleChildrenDeleteEvent = index => {
    dispatch(
      deleteChildrenInfo({
        targetDeleteIndex: index,
      }),
    );
  };

  const bottomStepArea = () => {
    return (
      <>
        {/* <RegisterMain ref={registerMainRef}></RegisterMain> */}
        <div className="con-bottom box-shadow">
          <div className="btn-area">
            <div className="box-btns-left">
              <SatButton
                styleClass="btn-s b-blue3"
                label="초기화"
                onClick={() => setIsShowResetPopup(true)}
              />
            </div>
            <div className="box-btns-center">
              <SatButton
                styleClass="btn-s blue btn-wide"
                // styleClass={delBtnStatus ? 'btn-s blue' : 'btn-s gray'}
                onClick={handleCheckAgeInfo}
                disabled={identifyBtnDisabled}
                label="확인 후 인증"
              />
            </div>

            {!isRestrictedUser && (
              <div className="box-btns-right">
                <SatButton
                  styleClass="btn-s b-blue3"
                  iconStyleClass="ico ico-sms"
                  onClick={() => setIsSmsSendPopupVisible(true)}
                  label="가입설계동의 SMS 발송"
                />
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <Layout bottomStepArea={bottomStepArea()}>
        <div className="vbox cc">
          <div className="step-box">
            <h3 className="tit-con">
              고객정보
              <TestAuth testType="register" />
            </h3>

            <CustomerRegisterInput registerRsdnKey={registerRsdnKey} />
            <SatInput
              ref={mobileTelNoRef}
              value={toPhone(registerCustomerInfo.mobileTelNo)}
              type="number"
              label="휴대전화번호"
              maxLength={11}
              border
              useMobile
              onChange={value => handleInputMobileTelNoEvent(value)}
            />
            <CustomerRegisterVerifyId
              registerDriverNumberKey={registerDriverNumberKey}
            />

            {registerCustomerInfo.relationCustomers &&
              registerCustomerInfo.relationCustomers.map((child, index) => {
                return (
                  <RegisterChildrenInput
                    key={index}
                    childName={child.name}
                    childRsdn1={child.rsdn1}
                    childRsdn2={child.rsdn2}
                    rsdnSecurityObj={child.rsdnSecurityObj?.value}
                    registerChildrenRsdnKey={registerChildrenRsdnKey + index}
                    index={index}
                    handleChildrenInputEvent={handleChildrenInputEvent}
                    handleChildrenDeleteEvent={handleChildrenDeleteEvent}
                  />
                );
              })}

            <div className="btn-area">
              <SatButton
                styleClass="btn-l blue3"
                onClick={handleAddChildrenClick}
                label="+ 자녀(만 19세 미만) 추가"
              />
            </div>
            <p className="text-info2 ico-type">
              미성년 자녀의 가입설계동의는 자녀 추가하기를 선택 하여 가능합니다.
            </p>
          </div>
        </div>

        <CustomerAuthSms
          isOpen={isShowAuthSmsPopup}
          customerInfo={registerCustomerInfo}
          onRetry={handleRetry}
          onVerify={handleVerifyAuthNo}
          onClose={clickCloseAuthSms}
        />

        <IdCheckTermsAgreePopup
          ref={agreePopupRef}
          inputComplete={inputComplete}
        />

        <SatModal
          visible={showRegisterPlanAgreement}
          type="fullPop"
          setVisible={() => setShowRegisterPlanAgreement(false)}
        >
          <RegisterPlanAgreement
            title="고객정보관리 및 가입 설계를 위한 상세 동의"
            handleCloseRegisterPlanAgreement={() => {
              setShowRegisterPlanAgreement(false);
              setIsShowAgreePopup(true);
            }}
            agreeCheckList={agreeCheckList}
            setAgreeCheckList={setAgreeCheckList}
          />
        </SatModal>

        <SatModal
          visible={isShowAgreePopup}
          setVisible={clickCloseTermsAgree}
          type="slide"
          render={() => (
            <TermsAgree
              inputComplete={inputComplete}
              show3rdTelco={is3rdTelCo(registerCustomerInfo.mobileCorp)}
              handleShowTerms={handleShowTerms}
              agreeCheckList={agreeCheckList}
              setAgreeCheckList={setAgreeCheckList}
              checkAgree2={checkAgree2}
              setCheckAgree2={setCheckAgree2}
            />
          )}
        />

        <SatModal visible={showMobiletermsAgree} type="fullPop">
          <MobileTermsAgree
            agentType={registerCustomerInfo.mobileCorp}
            onClose={() => {
              setShowMobiletermsAgree(false);
              setIsShowAgreePopup(true);
            }}
          />
        </SatModal>

        <SatModal
          visible={isSmsSendPopupVisible}
          type="confirm"
          setVisible={() => {
            setIsSmsSendPopupVisible(false);
          }}
        >
          <RegisterAgreeSmsSendPopupArea
            setIsSmsSendPopupVisible={setIsSmsSendPopupVisible}
          />
        </SatModal>

        <SatModal
          visible={isShowResetPopup}
          type="confirm"
          setVisible={() => {
            setIsShowResetPopup(false);
          }}
        >
          <>
            <div className="cont">
              <p className="layer-text info text-center">
                {`작업 하시던 가입설계동의 내용이 초기화 됩니다.`}
              </p>
            </div>
            <div className="btn-group">
              <SatButton
                styleClass="btn-half cancel"
                label={'취소'}
                onClick={() => setIsShowResetPopup(false)}
              />
              <SatButton
                styleClass="btn-half confirm"
                label={'초기화'}
                onClick={() => handleReset()}
              />
            </div>
          </>
        </SatModal>
      </Layout>
    </>
  );
};

export default CustomerAuth;
